"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var constants = require('./constants');

var sanitize = require('./sanitize');

var mock = require('./mock');

var ROOT_LOGGER = 'root';

var buildReference = function buildReference(ref) {
  return "".concat(constants.LOGGER_REFERENCE_PREFIX, " ").concat(ref, " ").concat(constants.LOGGER_REFERENCE_SUFFIX);
}; // This requires a subclass to extend and add a _logAtLevel class to handle the log levels


var Logger = /*#__PURE__*/function () {
  function Logger() {
    var modReference = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, Logger);

    // We wrap the prefix in the brackets to create a standard searchable term
    // in the logs
    this._prefix = !modReference ? '' : buildReference(modReference);
    this._loggerInstance = !modReference ? ROOT_LOGGER : modReference;
  }

  _createClass(Logger, [{
    key: "debug",
    value: function debug() {
      this._logAtLevel.apply(this, ['debug'].concat(_toConsumableArray(this._constructMessage.apply(this, arguments))));
    }
  }, {
    key: "info",
    value: function info() {
      this._logAtLevel.apply(this, ['info'].concat(_toConsumableArray(this._constructMessage.apply(this, arguments))));
    }
  }, {
    key: "warn",
    value: function warn() {
      this._logAtLevel.apply(this, ['warn'].concat(_toConsumableArray(this._constructMessage.apply(this, arguments))));
    }
  }, {
    key: "error",
    value: function error() {
      this._logAtLevel.apply(this, ['error'].concat(_toConsumableArray(this._constructMessage.apply(this, arguments))));
    } // The common case, and the one that we have to support because of backwards compatability, is just using the root
    // logger directly. If we do that, we don't want to prepend any module reference information to the message.

  }, {
    key: "_constructMessage",
    value: function _constructMessage() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this._loggerInstance === ROOT_LOGGER ? args : [this._prefix].concat(args);
    }
  }]);

  return Logger;
}();
/**
 * All of these fields are to maintain backwards compatibility
 */


Logger.prototype.mock = mock;
Logger.prototype.addSanitizedKeys = sanitize.addSanitizedKeys;
module.exports = Logger;